"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_native_1 = require("react-native");
const hooks_1 = require("../../hooks");
const TouchableItem_1 = require("../TouchableItem");
const ExternalLink = (props) => react_1.default.createElement(react_native_1.Text, Object.assign({}, props, { accessibilityRole: "link" }));
/**
 * 🔗 Link
 */
const Link = (props) => {
    const { method, routeName, path, params, onPress, replace } = props, rest = tslib_1.__rest(props, ["method", "routeName", "path", "params", "onPress", "replace"]);
    const navigation = hooks_1.useNavigation();
    if (!props.component) {
        return null;
    }
    const Component = props.component;
    function handlePress(event) {
        if (event && !event.defaultPrevented) {
            event.preventDefault();
            let fn = navigation.navigate;
            if (method) {
                fn = navigation[method];
            }
            if (replace === true) {
                fn = navigation.replace;
            }
            if (typeof routeName === 'string') {
                fn(routeName, params);
            }
            else if (typeof path === 'string') {
                fn({ path }, params);
            }
        }
    }
    return react_native_1.Platform.OS === 'web' && !!path && path !== '' ? (react_1.default.createElement(ExternalLink, Object.assign({}, rest, { href: path, onPress: onPress || handlePress }))) : (react_1.default.createElement(Component, Object.assign({}, rest, { onPress: onPress || handlePress })));
};
exports.Link = Link;
exports.Link.displayName = 'Link';
exports.Link.defaultProps = {
    component: TouchableItem_1.TouchableItem,
    replace: false,
};
